import { Component, Input, OnInit } from "@angular/core";
import { FormControl } from "@angular/forms";
import { MatProgressSpinnerModule } from "@angular/material";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as _ from "lodash";
import "rxjs/add/operator/map";
import "rxjs/add/operator/startWith";
import * as fromRootStore from "../../../reducers";
import { Combo2Service, ComboService } from "../../../services/index";
import { PurchaseOrderService } from "../../../services/purchaseorder.service";
declare var google;

@Component({
  selector: "purchase-plan",
  templateUrl: "purchasePlan.html",
})
export class purchasePlan implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input("params") params: any;
  @Input() active = false;
  @Input() dataContext;
  finyearList = [];
  isLoadMask: Promise<any>;
  loadingIndicator: boolean = true;
  seasonList = [];
  currentSlide: number = 0;
  IsWait: boolean = false;

  seasonCtrl: FormControl = new FormControl();
  finyearCtrl: FormControl = new FormControl();
  seasonfinList = [];
  styleList = [];
  varietyList = [];
  widthList = [];
  lumpList = [
    {
      lump: 100,
      lump_mtrs: 0,
      lump_ratio : 0,
      no_of_clrs: 0,
      clr_per_des: 3,
      tot_designs: 0,
      lump_tot_mtrs : 0,
      lump_tot_clrs : 0,
      lump_tot_designs : 0,
    },
    {
      lump: 200,
      lump_mtrs: 0,
      lump_ratio : 0,
      no_of_clrs: 0,
      clr_per_des: 3,
      tot_designs: 0,
      lump_tot_mtrs : 0,
      lump_tot_clrs : 0,
      lump_tot_designs : 0,
    },
  ];
  variety: string;
  style: string;

  planData = {
    fin_id: "",
    season_id: 0,
    season: "",
    total_qty: 0,
    fin_year: "",
  };

  constructor(
    public store: Store<fromRootStore.State>,
    private combo2Service: Combo2Service,
    public toasterService: ToasterService,
    public comboservice: ComboService,
    private spin: MatProgressSpinnerModule,
    private poservice: PurchaseOrderService
  ) {}

  ngOnInit(): void {
    this.finyearCombo();
    this.getPurchasePlanData();
  }

  ngAfterViewInit(): void {
    $("#finyear").focus();
  }

  onEnterKeyPressed(nextEl: string, ind, item) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      $("#" + nextEl).focus();
    }
  }

  applyFilter(): void {
    // this.getOrderList();
  }
  finyearCombo() {
    let that = this;
    this.combo2Service.finyearCombo().then((res: any) => {
      that.finyearList = res.data;
      let today = new Date();
      let dd = String(today.getDate()).padStart(2, "0");
      let mm = String(today.getMonth() + 1).padStart(2, "0");
      let yyyy = today.getFullYear();

      let checkDate = yyyy + "-" + mm + "-" + dd;
      let curYear = res.data.filter(
        (el) => checkDate >= el.start_date && checkDate <= el.end_date
      );
      if (curYear.length > 0) {
        this.finyearCtrl.setValue(curYear[0].fin_id);
        this.planData.fin_year = curYear[0].finyear;
        this.planData.fin_id = curYear[0].fin_id;
      } else {
        this.finyearCtrl.setValue(res.data[res.data["length"] - 1].fin_id);
        this.planData.fin_year = res[res["length"] - 1].finyear;
        this.planData.fin_id = res[res["length"] - 1].fin_id;
      }
      that.getSeasonList();
    });
  }

  getSeasonList() {
    let params = {
      date: new Date().getFullYear(),
      page: 1,
      start: 0,
      limit: 100,
    };
    this.comboservice.getBrandNewSeason(params).then((res: any) => {
      this.seasonList = res;
    });
  }

  onSelectFinyear(id) {
    this.planData.season_id = 0;
    var fin_id = id;
    // let seasonfinList = _.filter(this.seasonList, fin_id );
    let seasonfinList = this.seasonList.filter((res) => res.fin_id == fin_id);
    this.seasonfinList = seasonfinList;
    this.seasonCtrl.setValue(
      this.seasonfinList[this.seasonfinList["length"] - 1].season_id
    );
    this.planData.season_id = this.seasonfinList[
      this.seasonfinList["length"] - 1
    ].season_id;
    this.planData.season = this.seasonfinList[
      this.seasonfinList["length"] - 1
    ].season;
  }

  displayFinyear(comboType: string, id: number) {
    let list: any = [];
    if (comboType == "Finyear") {
      list = this.finyearList;
    }
    if (id && list.length > 0) {
      let fitem = _.find(list, { fin_id: id });
      return fitem["finyear"];
    }
    return "";
  }

  displayFn(comboType: string, id: number) {
    let list: any = [];
    let that = this;
    list = that.seasonList;

    if (id && list.length > 0) {
      let fitem = _.find(list, { season_id: id });
      this.planData.season = fitem["season"];
      return fitem["season"];
    }
    return "";
  }

  getPurchasePlanData() {
    this.IsWait = true;
    let params = {};
    this.poservice.getPurchasePlanData(params).then((res: any) => {
      this.IsWait = false;
      this.styleList = res.styleArr;
      // this.varietyList = res.varietyArr;
      this.widthList = res.widthArr;
      res.widthArr.forEach((el) => {
        el.lumpData = JSON.parse(JSON.stringify(this.lumpList));
      });
      res.varietyArr.forEach((el) => {
        el.width = JSON.parse(JSON.stringify(res.widthArr));
      });

      this.varietyList = res.varietyArr;
    });
  }

  onEnterRatio(ratio, style, index) {
    let styleListIndex = this.styleList.findIndex((el) => el.style == style);

    let styleQty = 0;

    if (styleListIndex != -1) {
      styleQty = this.styleList[styleListIndex].style_qty;
      this.varietyList[index].qty = Number(styleQty * (ratio / 100)).toFixed();
    }

    this.calcVarietyTotal(style, index, styleQty);
  }
  onEnterQty(qty, style, index) {
    let styleListIndex = this.styleList.findIndex((el) => el.style == style);

    let styleQty = 0;

    if (styleListIndex != -1) {
      styleQty = this.styleList[styleListIndex].style_qty;
      this.varietyList[index].ratio = (qty * (100 / styleQty)).toFixed(2);
    }

    this.calcVarietyTotal(style, index, styleQty);
  }

  onEnterStyleRatio(ratio, style, index) {
    if (this.checkExists()) {
      let totalQty = this.planData.total_qty;
      this.styleList[index].style_qty = Number(
        totalQty * (Number(ratio) / 100)
      ).toFixed();

      let total_ratio = this.styleList.reduce(
        (a, el) => a + el.style_percent,
        0
      );

      if (Number(total_ratio) > 100) {
        this.styleList[index].style_percent = 0;
        this.onEnterStyleRatio(0, style, index);
        this.toaster(
          "Percentage shouldn't exceed 100",
          "error",
          "Invalid data"
        );
      }
    } else {
      this.styleList[index].style_percent = 0;
    }
  }

  onEnterStyleQty(qty, style, index) {
    if (this.checkExists()) {
      let totalQty = this.planData.total_qty;
      this.styleList[index].style_percent = Number((qty / totalQty) * 100);

      let total_qty = this.styleList.reduce((a, el) => a + el.style_qty, 0);

      if (Number(total_qty) > totalQty) {
        this.styleList[index].style_qty = 0;
        this.onEnterStyleQty(0, style, index);
        this.toaster(
          "Style Qty shouldn't exceed Total.Qty",
          "error",
          "Invalid data"
        );
      }
    } else {
      this.styleList[index].style_qty = 0;
    }
  }

  calcVarietyTotal(style, index, styleQty) {
    this.styleList.forEach((el) => {
      if (el.style == style) {
        el.variety_total_qty = 0;
        el.variety_total_ratio = 0;

        this.varietyList.forEach((variety) => {
          if (el.style == variety.style) {
            el.variety_total_qty = (
              Number(el.variety_total_qty) + Number(variety.qty)
            ).toFixed();
            el.variety_total_ratio = (
              parseFloat(el.variety_total_ratio) + parseFloat(variety.ratio)
            ).toFixed(2) + "%";

            if (parseFloat(el.variety_total_ratio) > 100 && styleQty != el.variety_total_qty) {
              this.varietyList[index].ratio = 0;
              this.onEnterRatio(0, style, index);
              this.toaster(
                "Variety Qty shouln't exceed Style Qty",
                "error",
                "Invalid data"
              );
              return false;
            }
          }
        });
      }
    });
  }

  onEnterWidthPercent(style, per, variety, variety_ind, index) {
    let varietyListIndex = this.varietyList.findIndex(
      (el) => el.variety == variety
    );

    if (varietyListIndex != -1) {
      let varietyQty = Number(this.varietyList[varietyListIndex].qty).toFixed();
      this.varietyList[variety_ind].width[index].width_qty =
        (Number(varietyQty) * (per / 100)).toFixed();
    }

    this.calcVarietyWidthTotal(style, variety, variety_ind, index);
    this.onEnterWidthQtyConsumption(style, variety, variety_ind, index);
  }

  onEnterWidthQty(style, qty, variety, variety_ind, index) {
    let varietyListIndex = this.varietyList.findIndex(
      (el) => el.variety == variety
    );

    if (varietyListIndex != -1) {
      let varietyQty = this.varietyList[varietyListIndex].qty;
      this.varietyList[variety_ind].width[index].width_percent = (
        qty *
        (100 / varietyQty)
      ).toFixed(2);
    }

    this.calcVarietyWidthTotal(style, variety, variety_ind, index);
    this.onEnterWidthQtyConsumption(style, variety, variety_ind, index);
  }

  calcVarietyWidthTotal(style, variety, variety_ind, index) {
    this.varietyList.forEach((el) => {
      if (el.variety == variety) {
        el.width_total_qty = 0;
        el.width_total_ratio = 0;

        el.width.forEach((width) => {
          // if (el.width == width.style) {
          el.width_total_qty = (
            Number(el.width_total_qty) + Number(width.width_qty)
          ).toFixed();
          el.width_total_ratio = (
            parseFloat(el.width_total_ratio) + Number(width.width_percent)
          ).toFixed()  + "%";

          if (parseFloat(el.width_total_ratio) > 100) {
            el.width[index].width_percent = 0;
            this.onEnterWidthPercent(style, 0, variety, variety_ind, index);
            this.toaster(
              "Width Qty shouln't exceed Variety Qty",
              "error",
              "Invalid data"
            );
            return false;
          }
          // }
        });
      }
    });
    this.style = style;
    this.variety = variety;
  }

  onEnterWidthQtyConsumption(style, variety, variety_ind, index) {
    this.varietyList[variety_ind].width[index].mtrs =
      Number(this.varietyList[variety_ind].width[index].consumption) *
      this.varietyList[variety_ind].width[index].width_qty;

    this.calcVarietyWidthTotalCons(style, variety, variety_ind, index);
  }

  calcVarietyWidthTotalCons(style, variety, variety_ind, index) {
    this.varietyList.forEach((el) => {
      if (el.variety == variety) {
        el.width_total_mtrs = 0;

        el.width.forEach((width) => {
          el.width_total_mtrs = (
            Number(el.width_total_mtrs) + Number(width.mtrs)
          ).toFixed(2);
        });
      }
    });
  }

  onEnterLumpMtrs(
    style,
    width,
    variety,
    width_mtrs,
    lump_mtrs,
    var_index,
    width_index,
    lump_index
  ) {
    let changeIndex = -1;

    if (
      this.varietyList[var_index].width[width_index].lumpData[lump_index]
        .lump == 100
    ) {
      changeIndex = this.varietyList[var_index].width[
        width_index
      ].lumpData.findIndex((el) => el.lump == 200);
    } else {
      changeIndex = this.varietyList[var_index].width[
        width_index
      ].lumpData.findIndex((el) => el.lump == 100);
    }

    if (changeIndex != -1) {
      this.varietyList[var_index].width[width_index].lumpData[
        lump_index
      ].lump_ratio = Number((lump_mtrs / width_mtrs) * 100).toFixed();

      let balMtrs = (Number(width_mtrs) - Number(lump_mtrs)).toFixed();

      this.varietyList[var_index].width[width_index].lumpData[
        changeIndex
      ].lump_mtrs = balMtrs;

      this.varietyList[var_index].width[width_index].lumpData[
        changeIndex
      ].lump_ratio = Number((parseFloat(balMtrs) / width_mtrs) * 100).toFixed();

     

      this.varietyList[var_index].width[width_index].lumpData.forEach((el) => {
        el.no_of_clrs = 0;
        el.tot_designs = 0;

        el.no_of_clrs = (Number(el.lump_mtrs) / Number(el.lump)).toFixed();

        el.tot_designs = (
          Number(el.no_of_clrs) / Number(el.clr_per_des)
        ).toFixed();
      });

      this.calcVarietyWidthTotalLumpMtrs(
        style,
        width,
        variety,
        width_mtrs,
        lump_mtrs,
        var_index,
        width_index,
        lump_index
      );
    }
  }

  onEnterLumpRatio(
    style,
    width,
    variety,
    width_mtrs,
    lump_ratio,
    var_index,
    width_index,
    lump_index
  ) {
    let changeIndex = -1;

    if (
      this.varietyList[var_index].width[width_index].lumpData[lump_index]
        .lump == 100
    ) {
      changeIndex = this.varietyList[var_index].width[
        width_index
      ].lumpData.findIndex((el) => el.lump == 200);
    } else {
      changeIndex = this.varietyList[var_index].width[
        width_index
      ].lumpData.findIndex((el) => el.lump == 100);
    }

    if (changeIndex != -1) {
      

      this.varietyList[var_index].width[width_index].lumpData[
        lump_index
      ].lump_mtrs = Number(
        width_mtrs * (Number(lump_ratio) / 100)
      ).toFixed();

      let lump_mtrs =  Number(
        width_mtrs * (Number(lump_ratio) / 100)
      ).toFixed();

      this.varietyList[var_index].width[width_index].lumpData[
        changeIndex
      ].lump_ratio = (100 - lump_ratio).toFixed();

      let balRatio = 100 - lump_ratio;

      this.varietyList[var_index].width[width_index].lumpData[
        changeIndex
      ].lump_mtrs = Number(
        width_mtrs * (Number(balRatio) / 100)
      ).toFixed();

      this.varietyList[var_index].width[width_index].lumpData.forEach((el) => {
        el.no_of_clrs = 0;
        el.tot_designs = 0;
        el.width_total_clrs = 0;
        el.width_total_designs = 0;

        el.no_of_clrs = (Number(el.lump_mtrs) / Number(el.lump)).toFixed();

        el.tot_designs = (
          Number(el.no_of_clrs) / Number(el.clr_per_des)
        ).toFixed();
      });

      this.calcVarietyWidthTotalLumpMtrs(
        style,
        width,
        variety,
        width_mtrs,
        lump_mtrs,
        var_index,
        width_index,
        lump_index
      );
    }
  }

  calcVarietyWidthTotalLumpMtrs(
    style,
    width,
    variety,
    width_qty,
    lump_mtrs,
    var_index,
    width_index,
    lump_index
  ) {
    this.varietyList[var_index].lump_one_total_mtrs = 0;
    this.varietyList[var_index].lump_one_total_clrs = 0;
    this.varietyList[var_index].lump_one_total_designs = 0;

    this.varietyList[var_index].lump_two_total_mtrs = 0;
    this.varietyList[var_index].lump_two_total_clrs = 0;
    this.varietyList[var_index].lump_two_total_designs = 0;

    this.varietyList[var_index].lump_appr_tot_clrs = 0;
    this.varietyList[var_index].lump_appr_total_designs = 0;
    this.varietyList[var_index].lump_total_mtrs = 0;

    this.varietyList[var_index].width.forEach((el) => {
      el.lumpData.forEach((element) => {
        //static calculation for lumps wise total -100
        if(element.lump == 100){
          this.varietyList[var_index].lump_one_total_mtrs += Number(
            element.lump_mtrs
          );
          this.varietyList[var_index].lump_one_total_clrs += Number(
            element.no_of_clrs
          );
          this.varietyList[var_index].lump_one_total_designs += Number(
            element.tot_designs
          );
        }

        //static calculation for lumps wise total -200

        if(element.lump == 200){
          this.varietyList[var_index].lump_two_total_mtrs += Number(
            element.lump_mtrs
          );
          this.varietyList[var_index].lump_two_total_clrs += Number(
            element.no_of_clrs
          );
          this.varietyList[var_index].lump_two_total_designs += Number(
            element.tot_designs
          );
        }

        this.varietyList[var_index].lump_appr_tot_clrs += Number(
          element.no_of_clrs
        );
        this.varietyList[var_index].lump_appr_total_designs += Number(
          element.tot_designs
        );

        // lump total mtrs 

        this.varietyList[var_index].lump_total_mtrs += Number(
          element.lump_mtrs
        );
        
       
      });
    });

    this.varietyList[var_index].width.forEach(el => {
      el.width_total_clrs = 0;
      el.width_total_designs = 0;

      el.lumpData.forEach(el1 => {
        el.width_total_clrs += Number(el1.no_of_clrs);
        el.width_total_designs += Number(el1.tot_designs);
      });

      
    });
  }

  checkExists() {
    if (this.planData.total_qty == 0) {
      this.toaster("Please enter total qty", "error", "Invalid data");
      return false;
    }
    return true;
  }

  checkSlidedata(type) {
    let canMove = true;
    if (type != "BACK") {
      if (this.currentSlide == 0) {
        let totalQty = Number(this.planData.total_qty);

        let total_style_qty = this.styleList.reduce(
          (a, el) => a + Number(el.style_qty),
          0
        );

        let variety_total_qty = this.styleList.reduce(
          (a, el) => a + Number(el.variety_total_qty),
          0
        );

        if (
          totalQty == total_style_qty &&
          totalQty == variety_total_qty &&
          total_style_qty == variety_total_qty &&
          total_style_qty != 0 &&
          variety_total_qty != 0 &&
          totalQty != 0
        ) {
          canMove = false;
        } else {
          this.toaster(
            "Total Qty, Style Qty and Variety Qty must be equal (or) greater than 0",
            "error",
            "Invalid data"
          );
        }
      } else {
        let currIndex = this.varietyList.findIndex(
          (el) => el.style == this.style && el.variety == this.variety
        );

        if (currIndex != -1) {
          let totalQty = Number(this.varietyList[currIndex].qty);
          let total_width_qty = Number(
            this.varietyList[currIndex].width_total_qty
          );

          if (
            totalQty == total_width_qty &&
            Number(this.varietyList[currIndex].width_total_mtrs) ==
              this.varietyList[currIndex].lump_total_mtrs
          ) {
            canMove = false;
          } else {
            this.toaster(
              "Total Qty, Style Qty and Variety Qty must be equal",
              "error",
              "Invalid data"
            );
          }
        } else {
          canMove = false;
        }
      }
    } else {
      canMove = false;
    }

    if (!canMove) {
      this.onClickNext(type);
    }
  }

  onClickNext(type) {
    if (type == "NEXT") {
      this.savePurchasePlanData();
    } else if (type == "BACK") {
      this.currentSlide -= 1;
    }
  }

  savePurchasePlanData() {
    this.IsWait = true;
    let planData = { styleList: this.styleList, varietyList: this.varietyList };
    let params = {
      planData: JSON.stringify(planData),
      fin_id: this.planData.fin_id,
      fin_year: this.planData.fin_year,
      season_id: this.planData.season_id,
      season: this.planData.season,
      total_qty: this.planData.total_qty,
    };
    this.poservice.savePurchasePlan(params).then((res: any) => {
      this.IsWait = false;
      if (res.success) {
        this.toaster("Saved Successfully", "success", "Success");
        if (this.currentSlide < this.varietyList.length) {
          this.currentSlide += 1;
        }
      } else {
        this.toaster("Something went wrong", "error", "Invalid data");
      }
    });
  }

  toaster(message, type, title) {
    this.toasterService.pop({
      bodyOutputType: 1,
      type: type,
      title: title,
      body: message,
    });
  }

  getPurchasePlanDataLoaded() {
    this.IsWait = true;
    let params = {
      fin_id: this.planData.fin_id,
      fin_year: this.planData.fin_year,
      season_id: this.planData.season_id,
      season: this.planData.season,
    };
    this.poservice.getPurchasePlanDataLoaded(params).then((res: any) => {
      this.IsWait = false;
      if (res.success) {
        let planData = JSON.parse(res.planData[0].plan_data);
        this.varietyList = planData.varietyList;
        this.styleList = planData.styleList;
        this.planData.total_qty = res.planData[0].total_qty;
      } else {
        this.planData.total_qty = 0;
        this.getPurchasePlanData();
        this.toaster("No data found", "warning", "Oops...");
      }
    });
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Purchase/purchasePlan/purchasePlan.ts